<script setup lang="ts">
import { computed } from 'vue'
import { ElAvatar } from 'element-plus'
import Icon from '@/components/Icon/src/Icon.vue'

const props = defineProps<{
  avatar?: string
  name?: string
  size?: number
}>()

const avatarSize = computed(() => props.size ?? 24)

const showText = computed(() => props.name || '')
</script>

<template>
  <div class="avatar-with-name">
    <ElAvatar :size="avatarSize">
      <template v-if="props.avatar">
        <img :src="props.avatar" :alt="showText" />
      </template>
      <template v-else>
        <Icon icon="ep:user" />
      </template>
    </ElAvatar>
    <span v-if="showText" class="avatar-with-name__text">
      <slot>{{ showText }}</slot>
    </span>
  </div>
</template>

<style scoped lang="less">
.avatar-with-name {
  display: inline-flex;
  align-items: center;

  &__text {
    margin-left: 6px;
    white-space: nowrap;
  }
}
</style>
